<div class="notification-config-container">
  <ng-container *ngIf="!showForm; else configForm">
    <irembogov-notification-configuration-list
      [notifications]="notifications"
      (add)="onAddNew()"
      (edit)="onEdit($event)"
      (delete)="onDelete($event)"></irembogov-notification-configuration-list>
  </ng-container>

  <ng-template #configForm>
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <button
            (click)="onCancel()"
            class="btn btn-link text-decoration-none p-0">
            <i class="fa-solid fa-angles-left me-2"></i>
            Back to Configurations
          </button>
          <h6 class="mb-0">
            {{ selectedNotification ? 'Edit' : 'New' }} Configuration
          </h6>
        </div>

        <!-- State Selection -->
        <div class="mb-4">
          <irembogov-workflow-state-selector
            #stateSelector
            [workflowConfig]="workflowConfig"
            [initialState]="selectedNotification?.workflowContext"
            (stateSelected)="onStateSelected($event)">
          </irembogov-workflow-state-selector>
        </div>

        <!-- Assignment Form -->
        <ng-container *ngIf="selectedState">
          <irembogov-notification-configuration-form
            [workflowState]="getWorkflowState()"
            (notificationChange)="onNotificationChange($event)"
            [formFields]="formFields"
            (cancel)="onCancel()"
            [currentNotification]="
              getCurrentFormNotification()
            "></irembogov-notification-configuration-form>
        </ng-container>
      </div>
    </div>
  </ng-template>
</div>
